import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { saveUser } from '../auth';

export default function Connexion() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [erreur, setErreur] = useState('');

  const seConnecter = async () => {
    if (!email.trim() || !email.includes('@')) { setErreur('Email invalide'); return; }
    setLoading(true);
    setErreur('');
    try {
      const emailLower = email.toLowerCase().trim();
      const { data, error } = await supabase
        .from('users')
        .select('*')
        .eq('email', emailLower)
        .maybeSingle();

      if (error || !data) {
        setErreur('Email introuvable. Tu es bien inscrit ?');
        setLoading(false);
        return;
      }

      saveUser(data);
      const redirect = localStorage.getItem('wooki_redirect_after_inscription');
      if (redirect) {
        localStorage.removeItem('wooki_redirect_after_inscription');
        navigate(redirect);
      } else {
        navigate('/feed');
      }
    } catch (e) {
      setErreur('Erreur connexion. Réessaie.');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div onClick={() => navigate('/feed')} style={{ fontFamily: 'Fredoka One, cursive', fontSize: '2rem', marginBottom: 12, cursor: 'pointer' }}>
            <span style={{ color: '#3D9A6A' }}>Woo</span><span style={{ color: '#FF7043' }}>ki</span>
          </div>
          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: '#1C2B1E', marginBottom: 6 }}>Re-bonjour ! 👋</div>
          <div style={{ fontSize: '0.85rem', color: '#8A9E8D', lineHeight: 1.6 }}>Entre ton email pour te reconnecter</div>
        </div>

        <div style={{ background: 'white', borderRadius: 28, padding: '28px 24px', boxShadow: '0 8px 32px rgba(28,43,30,0.08)' }}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: '0.78rem', fontWeight: 800, color: '#4A6355', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'block' }}>Ton email</label>
            <input
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && seConnecter()}
              placeholder="exemple@gmail.com"
              type="email"
              style={{ width: '100%', padding: '14px 16px', border: '2px solid #E8EFE9', borderRadius: 16, fontFamily: 'Nunito, sans-serif', fontSize: '1rem', outline: 'none', background: '#FAFAF7', boxSizing: 'border-box' }}
            />
          </div>

          {erreur && (
            <div style={{ background: '#FFF3EE', color: '#FF7043', padding: '10px 14px', borderRadius: 12, fontSize: '0.82rem', marginBottom: 14, textAlign: 'center' }}>
              {erreur}
            </div>
          )}

          <button onClick={seConnecter} disabled={loading} style={{ width: '100%', padding: '17px', background: loading ? '#E8EFE9' : '#3D9A6A', color: loading ? '#8A9E8D' : 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1rem', cursor: loading ? 'not-allowed' : 'pointer', boxShadow: loading ? 'none' : '0 6px 20px rgba(61,154,106,0.35)', marginBottom: 12 }}>
            {loading ? '⏳ Connexion...' : '🌿 Me connecter'}
          </button>

          <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '16px 0' }}>
            <div style={{ flex: 1, height: 1, background: '#E8EFE9' }} />
            <div style={{ fontSize: '0.75rem', color: '#8A9E8D' }}>pas encore inscrit ?</div>
            <div style={{ flex: 1, height: 1, background: '#E8EFE9' }} />
          </div>

          <button onClick={() => navigate('/inscription')} style={{ width: '100%', padding: '14px', background: 'transparent', color: '#3D9A6A', border: '2px solid #C5DFC9', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.88rem', cursor: 'pointer' }}>
            Créer un compte →
          </button>
        </div>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: '0.75rem', color: '#8A9E8D' }}>
          🔒 Connexion sécurisée par ton email
        </div>
      </div>
    </div>
  );
}